"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getBinarySoundHeaders_1 = __importDefault(require("../getBinarySoundHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Updates the sound binary
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param soundId the id of sound to update
 * @param fileData The binary file to upload
 * @param filetype wav, mp3, etc.. this param is necessary for the call to succeed
 */
function updateSoundBinary(baseUrl, wardenToken, soundId, fileData, filetype) {
    return (0, http_client_1.default)({
        method: "PUT",
        url: baseUrl + "/v0/media/sound/" + soundId + "/binary?filetype=" + filetype,
        headers: __assign(__assign({}, (0, getBinarySoundHeaders_1.default)(wardenToken)), { "Content-Type": "application/octet-stream" }),
        data: fileData
    }).then(function (response) { return response.data; });
}
exports.default = updateSoundBinary;
